import { AddLeaderboardForm } from '@/modules/leaderboard/add-leaderboard';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/leaderboard/clone/$id')({
  component: CloneLeaderboardPage,
});

function CloneLeaderboardPage() {
  const { id } = Route.useParams();
  return <AddLeaderboardForm cloneId={id} />;
}
